export default "__VITE_ASSET__51df9d0c__"